import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './PicIcon.c.svg';

export const PicIcon = withIconWrapper(ReactComponent);
